import { FilledButton } from '../util/button';

interface ChangeCheckInButtonFieldProps {
  disable: boolean;
  onClick: () => void;
}
export const ChangeCheckInButtonField = ({
  disable,
  onClick,
}: ChangeCheckInButtonFieldProps) => {
  const handleClickConfirm = () => onClick();
  return (
    <div className={'next-button-field'}>
      <FilledButton
        onClick={handleClickConfirm}
        label={'上記内容で再予約する'}
        disabled={disable}
      />
    </div>
  );
};
